import {RainbowResponseVenue} from '../../server/rainbow/types';
import {parseJson} from '@treatwell/ui';
import {httpGetText} from './http';

export function composeFetchVenueInformation() {
  return ({venueId}: {venueId: string}) => {
    return httpGetText<string>({
      path: `/api/v1/venue/${venueId}`,
    }).then((response) => parseJson<RainbowResponseVenue>(response));
  };
}
